import {createContext} from 'react'

export const proyectoContext = createContext()

export default proyectoContext